import { lazy } from 'react';

const HomeIcon = lazy(() => import('./icons/HomeIcon'));
const SidebarIcon = lazy(() => import('./icons/SidebarIcon'));
const DoubleMessageIcon = lazy(() => import('./icons/DoubleMessageIcon'));
const CreateIcon = lazy(() => import('./icons/CreateIcon'));
const ConversationIcon = lazy(() => import('./icons/ConversationIcon'));
const LeapifyIcon = lazy(() => import('./icons/LeapifyIcon'));
const CSVIcon = lazy(() => import('./icons/CSVIcon'));
const DragIcon = lazy(() => import('./icons/DragIcon'));
const UploadThumbnailIcon = lazy(() => import('./icons/UploadThumbnailIcon'));
const ProfileIcon = lazy(() => import('./icons/ProfileIcon'));
const CalendarIcon = lazy(() => import('./icons/CalendarIcon'));
const WatchLoadingIcon = lazy(() => import('./icons/WatchLoadingIcon'));
const ToadIcon = lazy(() => import('./icons/ToadIcon'));
const SettingIcon = lazy(() => import('./icons/SettingIcon'));
const SalesIcon = lazy(() => import('./icons/SalesIcon'));
const NotFoundIcon = lazy(() => import('./icons/NotFoundIcon'));
const NoRecordIcon = lazy(() => import('./icons/NoRecordIcon'));
const AttachmentIcon = lazy(() => import('./icons/AttachmentIcon'));
const SearchIcon = lazy(() => import('./icons/SearchIcon'));
const MobileTextIcon = lazy(() => import('./icons/MobileTextIcon'));
const InfoIcon = lazy(() => import('./icons/InfoIcon'));
const ExportIcon = lazy(() => import('./icons/ExportIcon'));
const ImportExportIcon = lazy(() => import('./icons/ImportExportIcon'));
const ImportIcon = lazy(() => import('./icons/ImportIcon'));
const SorterIcon = lazy(() => import('./icons/SorterIcon'));
const BellIcon = lazy(() => import('./icons/BellIcon'));
const MoreIcon = lazy(() => import('./icons/MoreIcon'));
const CallLogIcon = lazy(() => import('./icons/CallLogIcon'));
const SMSLogIcon = lazy(() => import('./icons/SMSLogIcon'));
const ZoomIcon = lazy(() => import('./icons/ZoomIcon'));
const SwitcherIcon = lazy(() => import('./icons/SwitcherIcon'));
const PipelineIcon = lazy(() => import('./icons/PipelineIcon'));
const UnionIcon = lazy(() => import('./icons/UnionIcon'));
const WelcomeIcon = lazy(() => import('./icons/WelcomeIcon'));
const CheckIcon = lazy(() => import('./icons/CheckIcon'));
const LaptopIcon = lazy(() => import('./icons/LaptopIcon'));
const CloudApiIcon = lazy(() => import('./icons/CloudApiIcon'));
const MobilePhoneIcon = lazy(() => import('./icons/MobilePhoneIcon'));
const ReceiptIcon = lazy(() => import('./icons/ReceiptIcon'));
const InvoiceIcon = lazy(() => import('./icons/InvoiceIcon'));
const VideoIcon = lazy(() => import('./icons/VideoIcon'));
const EventBellIcon = lazy(() => import('./icons/EventBellIcon'));
const EventCancelledIcon = lazy(() => import('./icons/EventCancelledIcon'));
const FileIcon = lazy(() => import('./icons/FileIcon'));
const EventDateTimeIcon = lazy(() => import('./icons/EventDateTimeIcon'));
const TrashIcon = lazy(() => import('./icons/TrashIcon'));
const TimeIcon = lazy(() => import('./icons/TimeIcon'));
const CopyIcon = lazy(() => import('./icons/CopyIcon'));
const MailIcon = lazy(() => import('./icons/MailIcon'));
const SMSIcon = lazy(() => import('./icons/SMSIcon'));
const PlusIcon = lazy(() => import('./icons/PlusIcon'));
const StackIcon = lazy(() => import('./icons/StackIcon'));
const AutomationIcon = lazy(() => import('./icons/AutomationIcon'));
const TagIcon = lazy(() => import('./icons/TagIcon'));
const InboxIcon = lazy(() => import('./icons/InboxIcon'));
const FinishIcon = lazy(() => import('./icons/FinishIcon'));
const EmailCloseIcon = lazy(() => import('./icons/EmailCloseIcon'));
const EmailOpenIcon = lazy(() => import('./icons/EmailOpenIcon'));
const GmailIcon = lazy(() => import('./icons/integrations/GmailIcon'));
const SMGmailIcon = lazy(() => import('./icons/integrations/small/GmailIcon'));
const SMOutlookIcon = lazy(
  () => import('./icons/integrations/small/OutlookIcon'),
);
const OutlookIcon = lazy(() => import('./icons/integrations/OutlookIcon'));
const SMSPhoneIcon = lazy(() => import('./icons/SMSPhoneIcon'));
import LocationIcon from './icons/LocationIcon';
import ConditionIcon from './icons/ConditionIcon';
import ActionIcon from './icons/ActionIcon';
import EmailIcon from './icons/EmailIcon';
import WalletIcon from './icons/WalletIcon';
import ReferralLinkIcon from './icons/ReferralLinkIcon';
import CalendarCheckIcon from './icons/CalendarCheckIcon';
import PeopleIcon from './icons/PeopleIcon';
import GoogleMeetIcon from './icons/GoogleMeetIcon';
import DescriptionIcon from './icons/DescriptionIcon';
const SMSSettingsIcon = lazy(() => import('./icons/SMSSettingsIcon'));
const WebsiteGlobeIcon = lazy(() => import('./icons/WebsiteGlobeIcon'));
const ReportIcon = lazy(() => import('./icons/ReportIcon'));
const LeadsIcon = lazy(() => import('./icons/LeadsIcon'));
const GuestIcon = lazy(() => import('./icons/GuestIcon'));
const AICallerIcon = lazy(() => import('./icons/AICallerIcon'));
const AICallerSettingsIcon = lazy(() => import('./icons/AICallerSettingsIcon'));

export {
  WebsiteGlobeIcon,
  ReportIcon,
  LeadsIcon,
  GuestIcon,
  MobilePhoneIcon,
  CloudApiIcon,
  LaptopIcon,
  HomeIcon,
  SidebarIcon,
  DoubleMessageIcon,
  CreateIcon,
  LeapifyIcon,
  CSVIcon,
  DragIcon,
  UploadThumbnailIcon,
  ProfileIcon,
  CalendarIcon,
  WatchLoadingIcon,
  ToadIcon,
  SettingIcon,
  SalesIcon,
  NotFoundIcon,
  NoRecordIcon,
  AttachmentIcon,
  SearchIcon,
  MobileTextIcon,
  InfoIcon,
  ExportIcon,
  ImportExportIcon,
  ImportIcon,
  SorterIcon,
  BellIcon,
  MoreIcon,
  CallLogIcon,
  SMSLogIcon,
  GoogleMeetIcon,
  ZoomIcon,
  SwitcherIcon,
  PipelineIcon,
  UnionIcon,
  WelcomeIcon,
  CheckIcon,
  CalendarCheckIcon,
  DescriptionIcon,
  PeopleIcon,
  ReceiptIcon,
  InvoiceIcon,
  VideoIcon,
  EventBellIcon,
  EventCancelledIcon,
  FileIcon,
  EventDateTimeIcon,
  LocationIcon,
  TrashIcon,
  TimeIcon,
  CopyIcon,
  MailIcon,
  SMSIcon,
  PlusIcon,
  StackIcon,
  AutomationIcon,
  TagIcon,
  InboxIcon,
  FinishIcon,
  EmailCloseIcon,
  EmailOpenIcon,
  GmailIcon,
  SMGmailIcon,
  SMOutlookIcon,
  SMSPhoneIcon,
  OutlookIcon,
  ConditionIcon,
  ActionIcon,
  EmailIcon,
  WalletIcon,
  ReferralLinkIcon,
  ConversationIcon,
  SMSSettingsIcon,
  AICallerIcon,
  AICallerSettingsIcon,
};
